export default __webpack_public_path__ + "static/media/pz.6a6a004f.png";